import { useCallback } from 'react'
import { usePartnerPickDeviceSearchLazyQuery } from 'domains/partner-pick-devices/api'

interface UsePartnerPickDevicesSearchArgs {
  warehouseLocationId: string
  active?: boolean
  page: number
}

const PER_PAGE = 50

export const usePartnerPickDevicesSearch = () => {
  const [_fetch, { loading, error, data, fetchMore: _fetchMore }] =
    usePartnerPickDeviceSearchLazyQuery({
      fetchPolicy: 'network-only',
    })

  const fetchPartnerPickDevices = useCallback(
    ({ warehouseLocationId, active, page }: UsePartnerPickDevicesSearchArgs) => {
      _fetch({
        variables: {
          warehouseLocationId,
          active,
          limit: PER_PAGE,
          offset: (page - 1) * PER_PAGE,
        },
      })
    },
    [_fetch]
  )

  const fetchMore = useCallback(
    ({ warehouseLocationId, active, page }: UsePartnerPickDevicesSearchArgs) => {
      _fetchMore({
        variables: {
          warehouseLocationId,
          active,
          limit: PER_PAGE,
          offset: (page - 1) * PER_PAGE,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev

          // merge new results with original
          // https://www.apollographql.com/docs/react/v2/data/pagination/#offset-based
          return Object.assign(
            {},
            {
              partnerPickDeviceSearch: {
                ...prev.partnerPickDeviceSearch,
                devices: [
                  ...prev.partnerPickDeviceSearch.devices,
                  ...fetchMoreResult.partnerPickDeviceSearch.devices,
                ],
              },
            }
          )
        },
      })
    },
    [_fetchMore]
  )

  return {
    fetchPartnerPickDevices,
    fetchMore,
    apiData: data,
    apiLoading: loading,
    apiSuccess: Boolean(data),
    apiError: error,
  }
}
